import { Directive, OnInit, EventEmitter, Output, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { SortService } from 'app/core/services/sort.service';

@Directive({
	selector: '[appSortableTable]'
})
export class SortableTableDirective implements OnInit, OnDestroy {

	private columnSortedSubscription: Subscription;
	@Output() sorted = new EventEmitter();
	@Input() Id: string;
	constructor(private sortService: SortService) { }

	ngOnInit() {
		this.columnSortedSubscription = this.sortService.columnSorted$.subscribe(
			event => {
				this.sorted.emit(event);
			}
		);
	}

	ngOnDestroy() {
		this.columnSortedSubscription.unsubscribe();
	}
}